/** UI UX Pro Max design system tokens (Seedit overrides: primary = tenant brandColor). */

export const SEEDIT_FONT_FAMILY = '"Fira Sans", Arial, sans-serif';
export const SEEDIT_FONT_FAMILY_MONO = '"Fira Code", monospace';

export const SEEDIT_SEMANTIC_COLORS = {
  info: "#3B82F6",
  warning: "#F59E0B",
  /** Muted amber for contained warning buttons (alerts/icons keep `warning`). */
  buttonWarning: "#B45309"
} as const;

export const SEEDIT_LIGHT_SURFACES = {
  background: { default: "#F8FAFC", paper: "#FFFFFF" },
  text: { primary: "#0F172A", secondary: "#334155", disabled: "#8c8c8c" }
} as const;

export const SEEDIT_DARK_SURFACES = {
  background: { default: "#131421", paper: "#1e1f29" },
  text: { primary: "#ffffff", secondary: "#ececec", disabled: "#c4c4c4" }
} as const;

export const DEFAULT_BRAND_COLOR = "#006651";
